// extracted by mini-css-extract-plugin
export default {"heading":"SectionHeader2_heading__LmvQU","headingMarginDefault":"SectionHeader2_headingMarginDefault__1SoT7"};